const assetCardTabs = {
  item: [
    {
      label: "Images",
      type: "image",
      controls: [
        {
          id: "identifier",
          label: "Identifier",
          name: "identifier",
          type: "text",
          rules: {
            maxLength: 100,
          },
        },
        {
          id: "altText",
          label: "Alt Text",
          name: "altText",
          type: "text",
          rules: {
            maxLength: 125,
          },
        },
        {
          id: "longDescription",
          label: "Long Description",
          name: "longDescription",
          type: "text",
          rules: {
            multiline: true,
          },
        },
      ],
    },
    {
      label: "Graphics",
      type: "graphic",
    },
    {
      label: "Media",
      type: "media",
      controls: [
        {
          id: "description",
          label: "Description",
          name: "description",
          type: "text",
        },
      ],
    },
    {
      label: "Metafiles",
      type: "metafile",
      controls: [
        {
          id: "description",
          label: "Description",
          name: "description",
          type: "text",
        },
        {
          id: "isASL",
          label: "ASL",
          name: "isASL",
          type: "switch",
        },
        {
          id: "isPBT",
          label: "PBT",
          name: "isPBT",
          type: "switch",
        },
      ],
    },
    {
      label: "Program Metafiles",
      type: "program.metafile",
    },
  ],
  passage: [
    {
      label: "Images",
      type: "image",
      controls: [
        {
          id: "identifier",
          label: "Identifier",
          name: "identifier",
          type: "text",
          rules: {
            maxLength: 100,
          },
        },
        {
          id: "altText",
          label: "Alt Text",
          name: "altText",
          type: "text",
          rules: {
            maxLength: 125,
          },
        },
        {
          id: "longDescription",
          label: "Long Description",
          name: "longDescription",
          type: "text",
        },
      ],
    },
    {
      label: "Graphics",
      type: "graphic",
    },
    {
      label: "Metafiles",
      type: "metafile",
      controls: [
        {
          id: "description",
          label: "Description",
          name: "description",
          type: "text",
        },
        {
          id: "isASL",
          label: "ASL",
          name: "isASL",
          type: "switch",
        },
        {
          id: "isPBT",
          label: "PBT",
          name: "isPBT",
          type: "switch",
        },
      ],
    },
    {
      label: "Program Metafiles",
      type: "program.metafile",
    },
  ],
};

export { assetCardTabs };
